import KeyFlowVO from 'commons/vo/KeyFlowVO';
import {
  ReferenceType,
  KeyFlowResponseProps,
  PaginationType,
  ResponsePaginationType,
  ResponseWaitingCountType,
} from 'commons/framework/type';

export const initPagination = {
  ITEMCOUNT: 0,
  PAGECOUNT: 0,
  PAGENUMBER: 0,
};

class KeyFlowResponse<T extends KeyFlowVO> {
  result: T[];
  reference: ReferenceType;
  success: boolean;
  code: number;
  message: string;

  constructor(json: KeyFlowResponseProps) {
    this.result = json.result || [];
    this.reference = json.reference || initPagination;
    this.success = json.success === 'YES';
    this.code = json.code;
    this.message = json.message;
  }

  getResult(vo?: typeof KeyFlowVO) {
    if (vo) {
      const mappingItemList = [];
      const itemList = this.result;

      for (const index in itemList) {
        const item = itemList[index];

        const mappingItem = vo.mapping(item);

        mappingItemList.push(mappingItem);
      }

      return mappingItemList;
    }

    return this.result;
  }

  get page(): PaginationType {
    const { PAGENUMBER, PAGECOUNT, ITEMCOUNT }: ResponsePaginationType = this
      .reference as ResponsePaginationType;
    return {
      itemCount: Number(ITEMCOUNT),
      pageCount: Number(PAGECOUNT),
      pageNumber: Number(PAGENUMBER),
    };
  }

  get waitingCount() {
    const { WAITING_COUNT }: ResponseWaitingCountType = this.reference as ResponseWaitingCountType;
    return Number(WAITING_COUNT);
  }

  // static mapping = function (json) {
  //   let invalid = false;
  //   const keyList = ['result', 'reference', 'success', 'code', 'message'];

  //   for (const i in keyList) {
  //     const key = keyList[i];
  //     if (!json[key]) {
  //       invalid = true;
  //     }

  //     if (invalid) {
  //       break;
  //     }
  //   }

  //   if (!invalid) {
  //     return new KeyFlowResponse(json);
  //   } else {
  //     return null;
  //   }
  // };
}

export default KeyFlowResponse;
